import { render, staticRenderFns } from "./DirectExpansionDetails.vue?vue&type=template&id=701d536e&"
import script from "./DirectExpansionDetails.vue?vue&type=script&lang=js&"
export * from "./DirectExpansionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports